import request from '@/utils/request'

export function create(data) {

  return request({
    url: '/fileInfo/create',
    method: 'POST',
    data})
}

   

export function createBatch(data) {

  return request({
    url: '/fileInfo/create/batch',
    method: 'POST',
    data})
}

   

export function deleteById(data) {

  return request({
    url: '/fileInfo/deleteById',
    method: 'POST',
    data})
}

   

export function deleteByIds(data) {

  return request({
    url: '/fileInfo/deleteByIds',
    method: 'POST',
    data})
}

   

export function getById(params) {

  return request({
    url: '/fileInfo/getById',
    method: 'GET',
    params})
}

   

export function getByIds(params) {

  return request({
    url: '/fileInfo/getByIds',
    method: 'GET',
    params})
}

   

export function list(params) {

  return request({
    url: '/fileInfo/list',
    method: 'GET',
    params})
}

   

export function update(data) {

  return request({
    url: '/fileInfo/update',
    method: 'POST',
    data})
}

   

export function updateBatch(data) {

  return request({
    url: '/fileInfo/update/batch',
    method: 'POST',
    data})
}

   